import { zxcvbn, zxcvbnOptions, ZxcvbnResult } from '@zxcvbn-ts/core';

const loadOptions = async () => {
  // lazy load options to reduce main bundle size
  // @see https://zxcvbn-ts.github.io/zxcvbn/guide/lazy-loading/

  const zxcvbnCommonPackage = await import(
    /* webpackChunkName: "zxcvbnCommonPackage" */ '@zxcvbn-ts/language-common'
  );
  const zxcvbnEnPackage = await import(
    /* webpackChunkName: "zxcvbnEnPackage" */ '@zxcvbn-ts/language-en'
  );

  // @see https://zxcvbn-ts.github.io/zxcvbn/guide/options/
  return {
    dictionary: {
      ...zxcvbnCommonPackage.dictionary,
      ...zxcvbnEnPackage.dictionary,
    },
    graphs: zxcvbnCommonPackage.adjacencyGraphs,
    translations: zxcvbnEnPackage.translations,
  };
};

/**
 * Analyze a password
 * @param password the password
 * @param userInputs Optional user input (eg email, username, ...) to match against the password
 * @returns
 * @see https://zxcvbn-ts.github.io/zxcvbn/guide/
 */
export const analyzePassword = async (
  password: string,
  userInputs: string[] = [],
): Promise<ZxcvbnResult> => {
  const options = await loadOptions();
  zxcvbnOptions.setOptions(options);

  // Only send at most the first 100 characters
  // @see https://zxcvbn-ts.github.io/zxcvbn/guide/#performance
  const truncatedPassword = password.slice(0, 100);
  const results = zxcvbn(truncatedPassword, [
    ...userInputs,
    // always add "dotfile" to user input to prevent password containing dotfile
    'dotfile',
  ]);

  return results;
};
